import { render } from "./message-system.vue?vue&type=template&id=ebfdc9fc&scoped=true&ts=true"
import script from "./message-system.vue?vue&type=script&lang=ts"
export * from "./message-system.vue?vue&type=script&lang=ts"

import "./message-system.vue?vue&type=style&index=0&id=ebfdc9fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebfdc9fc"]])

export default __exports__